const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410323106',
            ext_path: '河南省 洛阳市 新安县 北冶镇',
            cid: '1',
            pid: '410323',
            name: '北冶镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.134728, 34.9092]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323107',
            ext_path: '河南省 洛阳市 新安县 仓头镇',
            cid: '2',
            pid: '410323',
            name: '仓头镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.231469, 34.874783]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323003',
            ext_path: '河南省 洛阳市 新安县 曹村乡',
            cid: '3',
            pid: '410323',
            name: '曹村乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.98238, 34.897883]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323100',
            ext_path: '河南省 洛阳市 新安县 城关镇',
            cid: '4',
            pid: '410323',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.15674, 34.738322]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323103',
            ext_path: '河南省 洛阳市 新安县 磁涧镇',
            cid: '5',
            pid: '410323',
            name: '磁涧镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.247727, 34.676773]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323105',
            ext_path: '河南省 洛阳市 新安县 南李村镇',
            cid: '6',
            pid: '410323',
            name: '南李村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.140015, 34.661465]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323109',
            ext_path: '河南省 洛阳市 新安县 石井镇',
            cid: '7',
            pid: '410323',
            name: '石井镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.052309, 34.997113]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323101',
            ext_path: '河南省 洛阳市 新安县 石寺镇',
            cid: '8',
            pid: '410323',
            name: '石寺镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.087566, 34.831786]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323104',
            ext_path: '河南省 洛阳市 新安县 铁门镇',
            cid: '9',
            pid: '410323',
            name: '铁门镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.054913, 34.739959]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323102',
            ext_path: '河南省 洛阳市 新安县 五头镇',
            cid: '10',
            pid: '410323',
            name: '五头镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.252979, 34.771184]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410323108',
            ext_path: '河南省 洛阳市 新安县 正村镇',
            cid: '11',
            pid: '410323',
            name: '正村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.1677, 34.806255]
        }
    }
];

export { d };
